import { render, staticRenderFns } from "./ItemContainer.vue?vue&type=template&id=3dcd86f2&scoped=true&"
import script from "./ItemContainer.vue?vue&type=script&lang=js&"
export * from "./ItemContainer.vue?vue&type=script&lang=js&"
import style0 from "./ItemContainer.vue?vue&type=style&index=0&id=3dcd86f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcd86f2",
  null
  
)

export default component.exports